/* PETAVIS sepeti — localStorage tabanlı.

   Gerçek Shopify ürünü olmadığı için sepet tarayıcıda tutuluyor.
   Ekleme / adet / silme / ara toplam / ücretsiz kargo çubuğu çalışır.
   Checkout KASTEN sipariş almaz — bkz. sections/pv-cart.liquid.

   Gerçek ürünler girildiğinde: addFromButton() içindeki kayıt yerine
   /cart/add.js çağrısı konur ve drawer Shopify sepetinden beslenir.
*/
(function () {
  'use strict';

  var KEY = 'petavis:cart';
  var THRESHOLD = 50;

  /* ------------------------------------------------------------- depolama */

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* kota dolu olabilir */
    }
    render();
    document.dispatchEvent(new CustomEvent('petavis:cart:changed', { detail: { items: items } }));
  }

  function money(n) {
    return '$' + Number(n || 0).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(name) {
    var base = window.PV_ASSET_BASE || '';
    return base ? base.replace('__NAME__', name) : name;
  }

  function lineKey(it) {
    return [it.handle, it.color || '', it.size || ''].join('::');
  }

  /* --------------------------------------------------------------- ekleme */

  function add(item) {
    var items = read();
    var k = lineKey(item);
    var found = items.filter(function (x) {
      return lineKey(x) === k;
    })[0];
    if (found) found.qty += item.qty || 1;
    else items.push({
      handle: item.handle,
      title: item.title,
      price: Number(item.price) || 0,
      image: item.image || '',
      color: item.color || '',
      size: item.size || '',
      qty: item.qty || 1,
    });
    write(items);
    open();
    flash();
  }

  function setQty(k, qty) {
    var items = read().map(function (x) {
      if (lineKey(x) === k) x.qty = Math.max(0, qty);
      return x;
    }).filter(function (x) {
      return x.qty > 0;
    });
    write(items);
  }

  function remove(k) {
    write(read().filter(function (x) {
      return lineKey(x) !== k;
    }));
  }

  function count() {
    return read().reduce(function (a, x) {
      return a + x.qty;
    }, 0);
  }

  function subtotal() {
    return read().reduce(function (a, x) {
      return a + x.price * x.qty;
    }, 0);
  }

  /* --------------------------------------------------------------- çizim */

  function render() {
    var items = read();
    var n = count();
    var sub = subtotal();

    // başlıktaki ve çekmecedeki sayaçlar
    document.querySelectorAll('[data-pv-cart-count], [data-pv-cart-badge]').forEach(function (el) {
      el.textContent = n;
    });

    var list = document.querySelector('[data-pv-cart-items]');
    var empty = document.querySelector('[data-pv-cart-empty]');
    var foot = document.querySelector('[data-pv-cart-foot]');
    if (!list) return;

    if (!items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
    } else {
      if (empty) empty.hidden = true;
      if (foot) foot.hidden = false;
      list.innerHTML = items.map(function (it) {
        var k = lineKey(it);
        var opts = [it.color, it.size].filter(Boolean).join(' · ');
        return (
          '<li class="pv-cart__item">' +
          '<span class="pv-cart__thumb">' +
          (it.image ? '<img src="' + imgUrl(it.image) + '" alt="" width="70" height="70" loading="lazy">' : '') +
          '</span>' +
          '<div class="pv-cart__info">' +
          '<p class="pv-cart__name">' + esc(it.title) + '</p>' +
          (opts ? '<p class="pv-cart__opts">' + esc(opts) + '</p>' : '') +
          '<div class="pv-cart__qty">' +
          '<button type="button" data-pv-qty="-1" data-k="' + esc(k) + '" aria-label="Decrease">&minus;</button>' +
          '<span>' + it.qty + '</span>' +
          '<button type="button" data-pv-qty="1" data-k="' + esc(k) + '" aria-label="Increase">+</button>' +
          '</div>' +
          '</div>' +
          '<div class="pv-cart__side">' +
          '<span class="pv-cart__price">' + money(it.price * it.qty) + '</span>' +
          '<button type="button" class="pv-cart__remove" data-pv-remove="' + esc(k) + '">Remove</button>' +
          '</div>' +
          '</li>'
        );
      }).join('');
    }

    var subEl = document.querySelector('[data-pv-cart-subtotal]');
    if (subEl) subEl.textContent = money(sub);

    renderShipping(sub, items.length);
  }

  function renderShipping(sub, hasItems) {
    var wrap = document.querySelector('[data-pv-cart-ship]');
    if (!wrap) return;
    if (!hasItems) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;

    var msg = wrap.querySelector('[data-pv-cart-ship-msg]');
    var bar = wrap.querySelector('[data-pv-cart-bar]');
    var pct = Math.min(100, (sub / THRESHOLD) * 100);
    if (bar) bar.style.width = pct + '%';

    if (sub >= THRESHOLD) {
      wrap.classList.add('is-free');
      if (msg) msg.innerHTML = '🎉 You have unlocked <b>free standard shipping</b>.';
    } else {
      wrap.classList.remove('is-free');
      var left = THRESHOLD - sub;
      if (msg) msg.innerHTML = 'Add <b>' + money(left) + '</b> more for <b>free standard shipping</b>.';
    }
  }

  /* --------------------------------------------------------- aç / kapat */

  function open() {
    var root = document.querySelector('[data-pv-cart]');
    if (!root) return;
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var root = document.querySelector('[data-pv-cart]');
    if (!root) return;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      root.hidden = true;
    }, 280);
  }

  function flash() {
    var badge = document.querySelector('[data-pv-cart-badge]');
    if (!badge) return;
    badge.classList.remove('is-bump');
    void badge.offsetWidth;
    badge.classList.add('is-bump');
  }

  /* ------------------------------------------------------------- bağlama */

  function bind() {
    var root = document.querySelector('[data-pv-cart]');
    if (!root || root.dataset.pvBound) {
      render();
      return;
    }
    root.dataset.pvBound = '1';

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pv-cart-close]');
      if (t) {
        e.preventDefault();
        close();
        return;
      }

      var openBtn = e.target.closest('[data-pv-cart-open]');
      if (openBtn) {
        e.preventDefault();
        open();
        return;
      }

      var q = e.target.closest('[data-pv-qty]');
      if (q) {
        var k = q.getAttribute('data-k');
        var d = parseInt(q.getAttribute('data-pv-qty'), 10);
        var cur = read().filter(function (x) { return lineKey(x) === k; })[0];
        if (cur) setQty(k, cur.qty + d);
        return;
      }

      var rm = e.target.closest('[data-pv-remove]');
      if (rm) {
        remove(rm.getAttribute('data-pv-remove'));
        return;
      }

      // ürün kartlarındaki hızlı ekleme
      var quick = e.target.closest('[data-pv-add][data-handle]');
      if (quick) {
        e.preventDefault();
        add({
          handle: quick.getAttribute('data-handle'),
          title: quick.getAttribute('data-title'),
          price: parseFloat(quick.getAttribute('data-price')) || 0,
          image: quick.getAttribute('data-image') || '',
          color: quick.getAttribute('data-color') || '',
          size: quick.getAttribute('data-size') || '',
          qty: 1,
        });
        return;
      }

      var co = e.target.closest('[data-pv-cart-checkout]');
      if (co) {
        var note = document.querySelector('[data-pv-cart-notice]');
        if (note) note.hidden = false;
        co.disabled = true;
        co.textContent = 'Checkout unavailable';
        setTimeout(function () {
          co.disabled = false;
          co.textContent = 'Checkout';
        }, 4000);
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    render();
  }

  /* ------------------------------------------------- dışarıya açılan API */

  window.PVCart = {
    add: add,
    open: open,
    close: close,
    count: count,
    subtotal: subtotal,
    items: read,
    threshold: function (v) {
      if (typeof v === 'number' && v >= 0) THRESHOLD = v;
      return THRESHOLD;
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
